import { RegistrosActionTypes } from './constants';

const INIT_STATE = {
    registro: {},
    listaRegistros: [],
    dataCharts: {},
    dataChartsComparisons: {},
    registrosForExcel: [],
    registrosForExcelRA: [],
    registrosItSendStat: [],
    loading: false,
    error: false,
    formSubmited: false
};

type RegistrosAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { registro?: {} | null, listaRegistros?: [] | null, loading?: boolean, +value ?: boolean };

const Registros = (state: State = INIT_STATE, action: RegistrosAction): any => {
    // console.log(action);
    switch (action.type) {
        case RegistrosActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case RegistrosActionTypes.LIST_REGISTROS: {
                    return {
                        ...state,
                        listaRegistros: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case RegistrosActionTypes.ADD_REGISTRO: {
                    return {
                        ...state,
                        registro: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case RegistrosActionTypes.GET_REGISTROS_FOR_EXCEL: {
                    return {
                        ...state,
                        registrosForExcel: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case RegistrosActionTypes.GET_REGISTROS_FOR_EXCEL_RA: {
                    return {
                        ...state,
                        registrosForExcelRA: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case RegistrosActionTypes.GET_REGISTROS_IT_SEND_STAT: {
                    return {
                        ...state,
                        registrosItSendStat: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case RegistrosActionTypes.GET_DATA_CHARTS: {
                    return {
                        ...state,
                        dataCharts: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case RegistrosActionTypes.GET_DATA_CHARTS_COMPARISONS: {
                    return {
                        ...state,
                        dataChartsComparisons: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                default:
                    return { ...state };
            }

        case RegistrosActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case RegistrosActionTypes.LIST_REGISTROS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaRegistros: [],
                        loading: false,
                    };
                }
                case RegistrosActionTypes.ADD_REGISTRO: {
                    return {
                        ...state,
                        registro: {},
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case RegistrosActionTypes.GET_REGISTROS_FOR_EXCEL: {
                    return {
                        ...state,
                        registrosForExcel: [],
                        error: action.payload.error,
                        loading: false,
                    };
                }
                case RegistrosActionTypes.GET_REGISTROS_FOR_EXCEL_RA: {
                    return {
                        ...state,
                        registrosForExcelRA: [],
                        error: action.payload.error,
                        loading: false,
                    };
                }
                case RegistrosActionTypes.GET_REGISTROS_IT_SEND_STAT: {
                    return {
                        ...state,
                        registrosItSendStat: [],
                        error: action.payload.error,
                        loading: false,
                    };
                }
                case RegistrosActionTypes.GET_DATA_CHARTS: {
                    return {
                        ...state,
                        dataCharts: {},
                        error: action.payload.error,
                        loading: false,
                    };
                }
                case RegistrosActionTypes.GET_DATA_CHARTS_COMPARISONS: {
                    return {
                        ...state,
                        dataChartsComparisons: {},
                        error: action.payload.error,
                        loading: false,
                    };
                }
                default:
                    return { ...state };
            }

        case RegistrosActionTypes.LIST_REGISTROS:
            return { ...state, error: false, loading: true };
        case RegistrosActionTypes.ADD_REGISTRO:
            return { ...state, error: false, loading: true };
        case RegistrosActionTypes.GET_REGISTROS_FOR_EXCEL:
            return { ...state, error: false, loading: true };
        case RegistrosActionTypes.GET_REGISTROS_FOR_EXCEL_RA:
            return { ...state, error: false, loading: true };
        case RegistrosActionTypes.GET_REGISTROS_IT_SEND_STAT:
            return { ...state, error: false, loading: true };
        case RegistrosActionTypes.GET_DATA_CHARTS:
            return { ...state, error: false, loading: true };
        case RegistrosActionTypes.GET_DATA_CHARTS_COMPARISONS:
            return { ...state, error: false, loading: true };
        case RegistrosActionTypes.RESET:
            return {
                ...state,
                listaRegistros: [],
                dataCharts: {},
                dataChartsComparisons: {},
                registrosForExcel: [],
                registrosForExcelRA: [],
                registrosItSendStat: [],
                loading: false,
                error: false,
                formSubmited: false
            };
            case RegistrosActionTypes.RESET_ALL:
            return {
                ...state,
                registro: {},
                listaRegistros: [],
                dataCharts: {},
                dataChartsComparisons: {},
                registrosForExcel: [],
                registrosForExcelRA: [],
                registrosItSendStat: [],
                loading: false,
                error: false,
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Registros;
